<mat-sidenav-container class="example-container" autosize>
  <mat-sidenav *ngIf="!hidden" [fixedInViewport]="true" #drawer class="example-sidenav" [ngClass]="{'mini-mode': isMiniMode}" mode="side" [opened]="true" [disableClose]="true">
    <app-left-toolbar class="toolbar" (toggleMiniMode)="onToggleMiniMode($event)"></app-left-toolbar>
  </mat-sidenav>
  <mat-sidenav-content [ngClass]="{'mini-sidebar': isMiniMode}">
    <div class="body background-gray">
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
  <div class="mobile" *ngIf="!hidden">
    <img [src]="localImages.smartAccountingLogo" alt="" height="100" width="100" />
  </div>
</mat-sidenav-container>